import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { colorsPalette } from '../../../../../shared/ui/styles/colors-palette';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';

interface YandexCloudNoticeProps {
  page: 'login' | 'register';
}

let YandexCloudNotice = function ({ page }: YandexCloudNoticeProps): ReactElement {
  const { t } = useTranslation();
  const { authorizationUiModule } = useUILogic();
  const manager = authorizationUiModule.module.yandexCloudManager;
  const errorKey = page === 'login' ? manager.loginErrorKey : manager.registrationErrorKey;
  const showInstructions = page === 'login' && manager.showLoginInstructions;

  if (!errorKey && !showInstructions) {
    return <></>;
  }

  return (
    <Wrapper>
      {errorKey && <ErrorText>{t(errorKey)}</ErrorText>}
      {showInstructions && (
        <InfoText>
          <div>{t('yandexCloud.notice.registeredAccount')}</div>
          <div>{t('yandexCloud.notice.registration')}</div>
        </InfoText>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
`;

const ErrorText = styled.div`
  color: ${colorsPalette.dustyRed500};
`;

const InfoText = styled.div`
  color: ${colorsPalette.gray700};
`;

YandexCloudNotice = observer(YandexCloudNotice);

export { YandexCloudNotice };
